/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faBookUser} from '@fortawesome/pro-duotone-svg-icons';

const GradebookIcon = ({icon, ...props}) => (
  <FontAwesomeIcon icon={faBookUser} {...props} />
);

export default GradebookIcon;
